// This file is auto-generated

import { Message, BinaryWriter, BinaryReader } from "google-protobuf";

import * as dep_1 from "./user";
import * as dep_2 from "./../tolemac/pub/filter";

export enum ContactTitle {
    UNDEFINED_ContactTitle = 0,
    SIR = 1,
    MADAM = 2,
    MISS = 3,
}
export interface IContact {
    id?: number;
    firstname?: string;
    lastname?: string;
    referrer?: string;
    birthname?: string;
    email?: string;
    phone?: string;
    cellphone?: string;
    address?: string;
    title?: ContactTitle;
    birthdate?: number;
    photo?: string;
    details?: string;
    isDeleted?: boolean;
    rqth?: boolean;
    proStatus?: string;
    followUp?: number;
    myedvennLastAccess?: number;
    moodleRef?: number;
    moodleSuspended?: boolean;
    moodleLastAccess?: number;
    adviser?: dep_1.IUser;
    mentor?: dep_1.IUser;

}
export class Contact implements IContact {

    id?: number;
    firstname?: string;
    lastname?: string;
    referrer?: string;
    birthname?: string;
    email?: string;
    phone?: string;
    cellphone?: string;
    address?: string;
    title?: ContactTitle;
    birthdate?: number;
    photo?: string;
    details?: string;
    isDeleted?: boolean;
    rqth?: boolean;
    proStatus?: string;
    followUp?: number;
    myedvennLastAccess?: number;
    moodleRef?: number;
    moodleSuspended?: boolean;
    moodleLastAccess?: number;
    adviser?: dep_1.User;
    mentor?: dep_1.User;

    constructor(data?: Partial<IContact>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MContact extends Message implements Contact {

    constructor(data?: Partial<IContact>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("id" in data && data.id != undefined) this.id = data.id;
            if ("firstname" in data && data.firstname != undefined) this.firstname = data.firstname;
            if ("lastname" in data && data.lastname != undefined) this.lastname = data.lastname;
            if ("referrer" in data && data.referrer != undefined) this.referrer = data.referrer;
            if ("birthname" in data && data.birthname != undefined) this.birthname = data.birthname;
            if ("email" in data && data.email != undefined) this.email = data.email;
            if ("phone" in data && data.phone != undefined) this.phone = data.phone;
            if ("cellphone" in data && data.cellphone != undefined) this.cellphone = data.cellphone;
            if ("address" in data && data.address != undefined) this.address = data.address;
            if ("title" in data && data.title != undefined) this.title = data.title;
            if ("birthdate" in data && data.birthdate != undefined) this.birthdate = data.birthdate;
            if ("photo" in data && data.photo != undefined) this.photo = data.photo;
            if ("details" in data && data.details != undefined) this.details = data.details;
            if ("isDeleted" in data && data.isDeleted != undefined) this.isDeleted = data.isDeleted;
            if ("rqth" in data && data.rqth != undefined) this.rqth = data.rqth;
            if ("proStatus" in data && data.proStatus != undefined) this.proStatus = data.proStatus;
            if ("followUp" in data && data.followUp != undefined) this.followUp = data.followUp;
            if ("myedvennLastAccess" in data && data.myedvennLastAccess != undefined) this.myedvennLastAccess = data.myedvennLastAccess;
            if ("moodleRef" in data && data.moodleRef != undefined) this.moodleRef = data.moodleRef;
            if ("moodleSuspended" in data && data.moodleSuspended != undefined) this.moodleSuspended = data.moodleSuspended;
            if ("moodleLastAccess" in data && data.moodleLastAccess != undefined) this.moodleLastAccess = data.moodleLastAccess;
            if ("adviser" in data && data.adviser != undefined) this.adviser = new dep_1.MUser(data.adviser);
            if ("mentor" in data && data.mentor != undefined) this.mentor = new dep_1.MUser(data.mentor);
        }
    }

    get id(): number {
        return Message.getField(this, 1) as number;
    }
    set id(value: number) {
        Message.setField(this, 1, value);
    }

    get firstname(): string {
        return Message.getField(this, 2) as string;
    }
    set firstname(value: string) {
        Message.setField(this, 2, value);
    }

    get lastname(): string {
        return Message.getField(this, 3) as string;
    }
    set lastname(value: string) {
        Message.setField(this, 3, value);
    }

    get referrer(): string {
        return Message.getField(this, 4) as string;
    }
    set referrer(value: string) {
        Message.setField(this, 4, value);
    }

    get birthname(): string {
        return Message.getField(this, 5) as string;
    }
    set birthname(value: string) {
        Message.setField(this, 5, value);
    }

    get email(): string {
        return Message.getField(this, 6) as string;
    }
    set email(value: string) {
        Message.setField(this, 6, value);
    }

    get phone(): string {
        return Message.getField(this, 7) as string;
    }
    set phone(value: string) {
        Message.setField(this, 7, value);
    }

    get cellphone(): string {
        return Message.getField(this, 8) as string;
    }
    set cellphone(value: string) {
        Message.setField(this, 8, value);
    }

    get address(): string {
        return Message.getField(this, 9) as string;
    }
    set address(value: string) {
        Message.setField(this, 9, value);
    }

    get title(): ContactTitle {
        return Message.getField(this, 10) as ContactTitle;
    }
    set title(value: ContactTitle) {
        Message.setField(this, 10, value);
    }

    get birthdate(): number {
        return Message.getField(this, 11) as number;
    }
    set birthdate(value: number) {
        Message.setField(this, 11, value);
    }

    get photo(): string {
        return Message.getField(this, 12) as string;
    }
    set photo(value: string) {
        Message.setField(this, 12, value);
    }

    get details(): string {
        return Message.getField(this, 13) as string;
    }
    set details(value: string) {
        Message.setField(this, 13, value);
    }

    get isDeleted(): boolean {
        return Message.getField(this, 14) as boolean;
    }
    set isDeleted(value: boolean) {
        Message.setField(this, 14, value);
    }

    get rqth(): boolean {
        return Message.getField(this, 15) as boolean;
    }
    set rqth(value: boolean) {
        Message.setField(this, 15, value);
    }

    get proStatus(): string {
        return Message.getField(this, 16) as string;
    }
    set proStatus(value: string) {
        Message.setField(this, 16, value);
    }

    get followUp(): number {
        return Message.getField(this, 17) as number;
    }
    set followUp(value: number) {
        Message.setField(this, 17, value);
    }

    get myedvennLastAccess(): number {
        return Message.getField(this, 18) as number;
    }
    set myedvennLastAccess(value: number) {
        Message.setField(this, 18, value);
    }

    get moodleRef(): number {
        return Message.getField(this, 30) as number;
    }
    set moodleRef(value: number) {
        Message.setField(this, 30, value);
    }

    get moodleSuspended(): boolean {
        return Message.getField(this, 31) as boolean;
    }
    set moodleSuspended(value: boolean) {
        Message.setField(this, 31, value);
    }

    get moodleLastAccess(): number {
        return Message.getField(this, 32) as number;
    }
    set moodleLastAccess(value: number) {
        Message.setField(this, 32, value);
    }

    get adviser(): dep_1.MUser {
        return Message.getWrapperField(this, dep_1.MUser, 40);
    }
    set adviser(value: dep_1.MUser) {
        Message.setWrapperField(this, 40, value);
    }

    get mentor(): dep_1.MUser {
        return Message.getWrapperField(this, dep_1.MUser, 41);
    }
    set mentor(value: dep_1.MUser) {
        Message.setWrapperField(this, 41, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new Contact() : {} as Contact;
        if (this.id != undefined) data.id = this.id;
        if (this.firstname != undefined) data.firstname = this.firstname;
        if (this.lastname != undefined) data.lastname = this.lastname;
        if (this.referrer != undefined) data.referrer = this.referrer;
        if (this.birthname != undefined) data.birthname = this.birthname;
        if (this.email != undefined) data.email = this.email;
        if (this.phone != undefined) data.phone = this.phone;
        if (this.cellphone != undefined) data.cellphone = this.cellphone;
        if (this.address != undefined) data.address = this.address;
        if (this.title != undefined) data.title = this.title;
        if (this.birthdate != undefined) data.birthdate = this.birthdate;
        if (this.photo != undefined) data.photo = this.photo;
        if (this.details != undefined) data.details = this.details;
        if (this.isDeleted != undefined) data.isDeleted = this.isDeleted;
        if (this.rqth != undefined) data.rqth = this.rqth;
        if (this.proStatus != undefined) data.proStatus = this.proStatus;
        if (this.followUp != undefined) data.followUp = this.followUp;
        if (this.myedvennLastAccess != undefined) data.myedvennLastAccess = this.myedvennLastAccess;
        if (this.moodleRef != undefined) data.moodleRef = this.moodleRef;
        if (this.moodleSuspended != undefined) data.moodleSuspended = this.moodleSuspended;
        if (this.moodleLastAccess != undefined) data.moodleLastAccess = this.moodleLastAccess;
        if (this.adviser != undefined) data.adviser = this.adviser.toObject(includeInstance);
        if (this.mentor != undefined) data.mentor = this.mentor.toObject(includeInstance);
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.id !== undefined) writer.writeInt32(1, this.id);
                if (this.firstname !== undefined) writer.writeString(2, this.firstname);
                if (this.lastname !== undefined) writer.writeString(3, this.lastname);
                if (this.referrer !== undefined) writer.writeString(4, this.referrer);
                if (this.birthname !== undefined) writer.writeString(5, this.birthname);
                if (this.email !== undefined) writer.writeString(6, this.email);
                if (this.phone !== undefined) writer.writeString(7, this.phone);
                if (this.cellphone !== undefined) writer.writeString(8, this.cellphone);
                if (this.address !== undefined) writer.writeString(9, this.address);
                if (this.title !== undefined) writer.writeEnum(10, this.title);
                if (this.birthdate !== undefined) writer.writeInt64(11, this.birthdate);
                if (this.photo !== undefined) writer.writeString(12, this.photo);
                if (this.details !== undefined) writer.writeString(13, this.details);
                if (this.isDeleted !== undefined) writer.writeBool(14, this.isDeleted);
                if (this.rqth !== undefined) writer.writeBool(15, this.rqth);
                if (this.proStatus !== undefined) writer.writeString(16, this.proStatus);
                if (this.followUp !== undefined) writer.writeInt64(17, this.followUp);
                if (this.myedvennLastAccess !== undefined) writer.writeInt64(18, this.myedvennLastAccess);
                if (this.moodleRef !== undefined) writer.writeInt32(30, this.moodleRef);
                if (this.moodleSuspended !== undefined) writer.writeBool(31, this.moodleSuspended);
                if (this.moodleLastAccess !== undefined) writer.writeInt64(32, this.moodleLastAccess);
                if (this.adviser !== undefined) writer.writeMessage(40, this.adviser, () => this.adviser.serialize(writer));
                if (this.mentor !== undefined) writer.writeMessage(41, this.mentor, () => this.mentor.serialize(writer));
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IContact): Uint8Array {
        return (data instanceof Message ? (data as MContact) : new MContact(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MContact {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MContact();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.id = reader.readInt32();
                    break;
            case 2:
                    message.firstname = reader.readString();
                    break;
            case 3:
                    message.lastname = reader.readString();
                    break;
            case 4:
                    message.referrer = reader.readString();
                    break;
            case 5:
                    message.birthname = reader.readString();
                    break;
            case 6:
                    message.email = reader.readString();
                    break;
            case 7:
                    message.phone = reader.readString();
                    break;
            case 8:
                    message.cellphone = reader.readString();
                    break;
            case 9:
                    message.address = reader.readString();
                    break;
            case 10:
                    message.title = reader.readEnum();
                    break;
            case 11:
                    message.birthdate = reader.readInt64();
                    break;
            case 12:
                    message.photo = reader.readString();
                    break;
            case 13:
                    message.details = reader.readString();
                    break;
            case 14:
                    message.isDeleted = reader.readBool();
                    break;
            case 15:
                    message.rqth = reader.readBool();
                    break;
            case 16:
                    message.proStatus = reader.readString();
                    break;
            case 17:
                    message.followUp = reader.readInt64();
                    break;
            case 18:
                    message.myedvennLastAccess = reader.readInt64();
                    break;
            case 30:
                    message.moodleRef = reader.readInt32();
                    break;
            case 31:
                    message.moodleSuspended = reader.readBool();
                    break;
            case 32:
                    message.moodleLastAccess = reader.readInt64();
                    break;
            case 40:
                    reader.readMessage(message.adviser, () => message.adviser = dep_1.MUser.deserialize(reader));
                    break;
            case 41:
                    reader.readMessage(message.mentor, () => message.mentor = dep_1.MUser.deserialize(reader));
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MContact {
        return MContact.deserializeBinaryFromReader(new MContact(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MContact, reader: BinaryReader) {
        return Object.assign(msg, MContact.deserialize(reader))
    };

}
export interface IContacts {
    values?: IContact[];
    count?: number;

}
export class Contacts implements IContacts {

    values?: Contact[];
    count?: number;

    constructor(data?: Partial<IContacts>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MContacts extends Message implements Contacts {

    constructor(data?: Partial<IContacts>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("values" in data && data.values != undefined) this.values = data.values.map(d => new MContact(d));
            if ("count" in data && data.count != undefined) this.count = data.count;
        }
    }

    get values(): MContact[] {
        return Message.getRepeatedWrapperField(this, MContact, 1);
    }
    set values(value: MContact[]) {
        Message.setRepeatedWrapperField(this, 1, value);
    }

    get count(): number {
        return Message.getField(this, 2) as number;
    }
    set count(value: number) {
        Message.setField(this, 2, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new Contacts() : {} as Contacts;
        if (this.values.length) data.values = this.values.map(d => d.toObject(includeInstance));

        if (this.count != undefined) data.count = this.count;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.values !== undefined) writer.writeRepeatedMessage(1, this.values, (i) => i.serialize(writer));
                if (this.count !== undefined) writer.writeInt32(2, this.count);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IContacts): Uint8Array {
        return (data instanceof Message ? (data as MContacts) : new MContacts(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MContacts {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MContacts();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    reader.readMessage(message.values, () => Message.addToRepeatedWrapperField(message, 1, MContact.deserialize(reader), MContact));
                    break;
            case 2:
                    message.count = reader.readInt32();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MContacts {
        return MContacts.deserializeBinaryFromReader(new MContacts(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MContacts, reader: BinaryReader) {
        return Object.assign(msg, MContacts.deserialize(reader))
    };

}
export interface IPostChangeEmail {
    currentEmail?: string;
    newEmail?: string;
    dryRun?: boolean;

}
export class PostChangeEmail implements IPostChangeEmail {

    currentEmail?: string;
    newEmail?: string;
    dryRun?: boolean;

    constructor(data?: Partial<IPostChangeEmail>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MPostChangeEmail extends Message implements PostChangeEmail {

    constructor(data?: Partial<IPostChangeEmail>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("currentEmail" in data && data.currentEmail != undefined) this.currentEmail = data.currentEmail;
            if ("newEmail" in data && data.newEmail != undefined) this.newEmail = data.newEmail;
            if ("dryRun" in data && data.dryRun != undefined) this.dryRun = data.dryRun;
        }
    }

    get currentEmail(): string {
        return Message.getField(this, 1) as string;
    }
    set currentEmail(value: string) {
        Message.setField(this, 1, value);
    }

    get newEmail(): string {
        return Message.getField(this, 2) as string;
    }
    set newEmail(value: string) {
        Message.setField(this, 2, value);
    }

    get dryRun(): boolean {
        return Message.getField(this, 3) as boolean;
    }
    set dryRun(value: boolean) {
        Message.setField(this, 3, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new PostChangeEmail() : {} as PostChangeEmail;
        if (this.currentEmail != undefined) data.currentEmail = this.currentEmail;
        if (this.newEmail != undefined) data.newEmail = this.newEmail;
        if (this.dryRun != undefined) data.dryRun = this.dryRun;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.currentEmail !== undefined) writer.writeString(1, this.currentEmail);
                if (this.newEmail !== undefined) writer.writeString(2, this.newEmail);
                if (this.dryRun !== undefined) writer.writeBool(3, this.dryRun);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IPostChangeEmail): Uint8Array {
        return (data instanceof Message ? (data as MPostChangeEmail) : new MPostChangeEmail(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MPostChangeEmail {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MPostChangeEmail();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.currentEmail = reader.readString();
                    break;
            case 2:
                    message.newEmail = reader.readString();
                    break;
            case 3:
                    message.dryRun = reader.readBool();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MPostChangeEmail {
        return MPostChangeEmail.deserializeBinaryFromReader(new MPostChangeEmail(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MPostChangeEmail, reader: BinaryReader) {
        return Object.assign(msg, MPostChangeEmail.deserialize(reader))
    };

}
export interface IPostChangeEmailResp {
    messages?: string[];

}
export class PostChangeEmailResp implements IPostChangeEmailResp {

    messages?: string[];

    constructor(data?: Partial<IPostChangeEmailResp>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MPostChangeEmailResp extends Message implements PostChangeEmailResp {

    constructor(data?: Partial<IPostChangeEmailResp>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("messages" in data && data.messages != undefined) this.messages = data.messages;
        }
    }

    get messages(): string[] {
        return Message.getField(this, 1) as string[];
    }
    set messages(value: string[]) {
        Message.setField(this, 1, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new PostChangeEmailResp() : {} as PostChangeEmailResp;
        if (this.messages?.length) data.messages = this.messages;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.messages !== undefined) writer.writeRepeatedString(1, this.messages);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IPostChangeEmailResp): Uint8Array {
        return (data instanceof Message ? (data as MPostChangeEmailResp) : new MPostChangeEmailResp(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MPostChangeEmailResp {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MPostChangeEmailResp();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    Message.addToRepeatedField(message, 1, reader.readString());
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MPostChangeEmailResp {
        return MPostChangeEmailResp.deserializeBinaryFromReader(new MPostChangeEmailResp(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MPostChangeEmailResp, reader: BinaryReader) {
        return Object.assign(msg, MPostChangeEmailResp.deserialize(reader))
    };

}
                        




export default () => {}